// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PresentationApprovalRequestsTable_RequestFragment = { __typename?: 'PresentationApprovalRequest', id: string, kind: Types.PresentationApprovalRequestKind, createdAt: Time, requestedApproverID: string, user: { __typename?: 'User', id: string, displayName: string }, household: { __typename?: 'Household', id: string, displayName: string }, presentation: { __typename?: 'ClientPresentationV2', id: string, name: string } };

export type PresentationApprovalRequestsTableQueryVariables = Types.Exact<{
  first: Types.Scalars['Int']['input'];
}>;


export type PresentationApprovalRequestsTableQuery = { __typename?: 'Query', pendingPresentationApprovalRequests: { __typename?: 'PresentationApprovalRequestConnection', edges?: Array<{ __typename?: 'PresentationApprovalRequestEdge', node?: (
        { __typename?: 'PresentationApprovalRequest' }
        & PresentationApprovalRequestsTable_RequestFragment
      ) | null } | null> | null } };

export const Operations = {
  Query: {
    PresentationApprovalRequestsTable: 'PresentationApprovalRequestsTable' as const
  },
  Fragment: {
    PresentationApprovalRequestsTable_Request: 'PresentationApprovalRequestsTable_Request' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const PresentationApprovalRequestsTable_RequestFragmentDoc = gql`
    fragment PresentationApprovalRequestsTable_Request on PresentationApprovalRequest {
  id
  kind
  createdAt
  requestedApproverID
  user {
    id
    displayName
  }
  household {
    id
    displayName
  }
  presentation {
    id
    name
  }
}
    `;
export const PresentationApprovalRequestsTableDocument = gql`
    query PresentationApprovalRequestsTable($first: Int!) {
  pendingPresentationApprovalRequests(
    first: $first
    orderBy: [{field: created_at, direction: DESC}]
  ) {
    edges {
      node {
        ...PresentationApprovalRequestsTable_Request
      }
    }
  }
}
    ${PresentationApprovalRequestsTable_RequestFragmentDoc}`;

/**
 * __usePresentationApprovalRequestsTableQuery__
 *
 * To run a query within a React component, call `usePresentationApprovalRequestsTableQuery` and pass it any options that fit your needs.
 * When your component renders, `usePresentationApprovalRequestsTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePresentationApprovalRequestsTableQuery({
 *   variables: {
 *      first: // value for 'first'
 *   },
 * });
 */
export function usePresentationApprovalRequestsTableQuery(baseOptions: Apollo.QueryHookOptions<PresentationApprovalRequestsTableQuery, PresentationApprovalRequestsTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PresentationApprovalRequestsTableQuery, PresentationApprovalRequestsTableQueryVariables>(PresentationApprovalRequestsTableDocument, withFetchPolicyContext(options));
      }
export function usePresentationApprovalRequestsTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PresentationApprovalRequestsTableQuery, PresentationApprovalRequestsTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PresentationApprovalRequestsTableQuery, PresentationApprovalRequestsTableQueryVariables>(PresentationApprovalRequestsTableDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function usePresentationApprovalRequestsTableSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PresentationApprovalRequestsTableQuery, PresentationApprovalRequestsTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PresentationApprovalRequestsTableQuery, PresentationApprovalRequestsTableQueryVariables>(PresentationApprovalRequestsTableDocument, withFetchPolicyContext(options));
        }
export type PresentationApprovalRequestsTableQueryHookResult = ReturnType<typeof usePresentationApprovalRequestsTableQuery>;
export type PresentationApprovalRequestsTableLazyQueryHookResult = ReturnType<typeof usePresentationApprovalRequestsTableLazyQuery>;
export type PresentationApprovalRequestsTableSuspenseQueryHookResult = ReturnType<typeof usePresentationApprovalRequestsTableSuspenseQuery>;
export type PresentationApprovalRequestsTableQueryResult = Apollo.QueryResult<PresentationApprovalRequestsTableQuery, PresentationApprovalRequestsTableQueryVariables>;